<template>
  <svg
    :height="height"
    alt="Belize Immigration Services Portal"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 144.73 16.61"
  >
    <!--belize immigration-->
    <path
      d="M6.59,6.11H9.27c1.62,0,2.88.44,2.88,1.94a1.79,1.79,0,0,1-1,1.68v0a1.79,1.79,0,0,1,1.42,1.84c0,1.59-1.35,2.3-3,2.3H6.59Zm2.6,3.13c.86,0,1.23-.36,1.23-.93S10,7.47,9.2,7.47H8.36V9.24Zm.16,3.32c1,0,1.46-.34,1.46-1.05s-.49-1-1.46-1h-1v2ZM15.88,6.11h4.9V7.59H17.65V9.16h2.66v1.48H17.65v1.8H20.9v1.48h-5ZM24.5,6.11h1.77v6.33h3.08v1.48H24.5ZM32.74,6.11h1.77v7.81H32.74ZM37.89,12.86l3.45-5.27H38.21V6.11h5.31V7.17l-3.45,5.27h3.48v1.48H37.89ZM46.81,6.11H51.7V7.59H48.57V9.16h2.67v1.48H48.57v1.8h3.25v1.48h-5ZM59.85,6.11h1.77v7.81H59.85ZM65.49,6.11h1.93l1.27,3.47c.15.46.29,1,.45,1.44h0c.16-.48.29-1,.45-1.44l1.23-3.47h1.93v7.81H71.18V11.06c0-.77.14-1.9.22-2.66h0l-.65,1.85-1.1,3h-1l-1.11-3L66.9,8.4h-.05c.08.76.23,1.89.23,2.66v2.86H65.49Z  M76.67,6.11H78.6l1.27,3.47c.16.46.29,1,.45,1.44h.05c.15-.48.29-1,.44-1.44L82,6.11H84v7.81H82.36V11.06a26.27,26.27,0,0,1,.23-2.66h0l-.64,1.85-1.11,3h-1l-1.11-3L78.08,8.4h0a26.27,26.27,0,0,1,.23,2.66v2.86H76.67Z  M87.85,6.11h1.76v7.81H87.85Z  M93.13,10.06A3.78,3.78,0,0,1,96.94,6,3.37,3.37,0,0,1,99.4,7l-.93,1.13A2,2,0,0,0,97,7.49c-1.21,0-2.06.94-2.06,2.51s.73,2.54,2.2,2.54a1.43,1.43,0,0,0,.83-.23V11h-1.3V9.52h2.87v3.6a3.77,3.77,0,0,1-2.58,1A3.66,3.66,0,0,1,93.13,10.06Z  M103.18,6.11H106c1.65,0,3,.57,3,2.43s-1.36,2.57-3,2.57h-1v2.81h-1.77Zm2.67,3.6c.93,0,1.43-.4,1.43-1.17s-.5-1-1.43-1H105v2.2Zm-.18.94,1.23-1.14,2.49,4.41h-2Z  M113.92,6.11H116l2.45,7.81h-1.87l-1-4c-.22-.78-.43-1.7-.63-2.52h0c-.19.83-.4,1.74-.62,2.52l-1,4h-1.81Zm-.83,4.58h3.76v1.37h-3.76Z  M122,7.59h-2.15V6.11H126V7.59h-2.15v6.33H122Z  M129.21,6.11H131v7.81h-1.77Z  M134.48,10c0-2.55,1.44-4,3.55-4s3.55,1.48,3.55,4-1.44,4.09-3.55,4.09S134.48,12.54,134.48,10Zm5.29,0c0-1.57-.67-2.49-1.74-2.49s-1.74.92-1.74,2.49.67,2.56,1.74,2.56S139.77,11.55,139.77,10Z  M145.1,6.11h1.81L149,10l.77,1.72h.05c-.08-.82-.23-1.92-.23-2.84V6.11h1.69v7.81h-1.81l-2-3.89-.78-1.71h0c.08.86.22,1.91.22,2.83v2.77H145.1Z"
      transform="translate(-6.5 -5.96)"
      fill="url(#paint0_linear)"
    />

    <!--services portal-->
    <path
      :fill="colorsComputed.start"
      d="M6.5,22l.4-.48a1.53,1.53,0,0,0,1,.45c.44,0,.69-.2.69-.51S8.35,21,8,20.88l-.54-.23a1.12,1.12,0,0,1-.79-1A1.2,1.2,0,0,1,8,18.5a1.71,1.71,0,0,1,1.21.5l-.35.45A1.24,1.24,0,0,0,8,19.11c-.37,0-.61.17-.61.46s.3.42.62.56l.53.22a1.08,1.08,0,0,1,.8,1,1.25,1.25,0,0,1-1.41,1.17A2,2,0,0,1,6.5,22Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M10.63,18.58H13v.58H11.33v1h1.41v.58H11.33v1.16h1.72v.59H10.63Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M14.46,18.58h1.32c.82,0,1.45.28,1.45,1.16S16.6,21,15.78,21h-.62V22.5h-.7Zm1.25,1.83c.54,0,.83-.22.83-.67s-.29-.61-.83-.61h-.55v1.28Zm-.06.37.51-.42,1.22,2.14H16.6Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M18.07,18.58h.74l.55,2c.12.44.21.83.34,1.27h0c.13-.44.22-.83.34-1.27l.55-2h.71L20.11,22.5h-.82Z"
      transform="translate(-6.5 -5.96)"
    />
    <path :fill="colorsComputed.start" d="M22.37,18.58h.7V22.5h-.7Z" transform="translate(-6.5 -5.96)" />
    <path
      :fill="colorsComputed.start"
      d="M24.46,20.55a1.84,1.84,0,0,1,1.79-2.05,1.56,1.56,0,0,1,1.13.5l-.37.45a1,1,0,0,0-.74-.34c-.64,0-1.1.54-1.1,1.42S25.59,22,26.25,22a1.09,1.09,0,0,0,.84-.41l.37.44a1.57,1.57,0,0,1-1.24.57A1.79,1.79,0,0,1,24.46,20.55Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M28.72,18.58h2.36v.58H29.41v1h1.41v.58H29.41v1.16h1.73v.59H28.72Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M32.28,22l.4-.48a1.53,1.53,0,0,0,1,.45c.45,0,.69-.2.69-.51s-.26-.43-.61-.58l-.54-.23a1.13,1.13,0,0,1-.79-1,1.2,1.2,0,0,1,1.32-1.11A1.73,1.73,0,0,1,35,19l-.36.45a1.24,1.24,0,0,0-.85-.34c-.38,0-.62.17-.62.46s.3.42.63.56l.53.22a1.09,1.09,0,0,1,.79,1,1.25,1.25,0,0,1-1.41,1.17A2,2,0,0,1,32.28,22Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M38.22,18.58h1.23c.87,0,1.52.3,1.52,1.21s-.65,1.27-1.49,1.27h-.57V22.5h-.69Zm1.2,1.92c.58,0,.86-.23.86-.71s-.3-.66-.89-.66h-.48V20.5Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M42.1,20.52c0-1.27.71-2,1.73-2s1.73.76,1.73,2-.71,2.05-1.73,2.05S42.1,21.79,42.1,20.52Zm2.75,0c0-.88-.4-1.41-1-1.41s-1,.53-1,1.41.39,1.45,1,1.45S44.85,21.4,44.85,20.52Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M47,18.58h1.32c.82,0,1.45.28,1.45,1.16S49.09,21,48.27,21h-.62V22.5H47Zm1.25,1.83c.54,0,.83-.22.83-.67s-.29-.61-.83-.61h-.55v1.28Zm-.06.37.51-.42,1.22,2.14h-.78Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M51.8,19.16H50.67v-.58h3v.58H52.5V22.5h-.7Z"
      transform="translate(-6.5 -5.96)"
    />
    <path
      :fill="colorsComputed.start"
      d="M55.41,18.58h.82l1.28,3.92h-.74l-.6-2.09c-.12-.41-.24-.86-.35-1.29h0c-.1.43-.22.88-.34,1.29l-.61,2.09h-.71Zm-.52,2.31h1.85v.55H54.89Z"
      transform="translate(-6.5 -5.96)"
    />
    <path :fill="colorsComputed.start" d="M58.56,18.58h.69v3.33h1.63v.59H58.56Z" transform="translate(-6.5 -5.96)" />
    <defs>
      <linearGradient id="paint0_linear" gradientUnits="userSpaceOnUse" x1="0" x2="357.64" y1="56.1386" y2="56.1386">
        <stop :stop-color="colorsComputed.end" />
        <stop :stop-color="colorsComputed.start" offset="1" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 30,
    start: '#ffffff',
    end: '#caf0f8',
  },
)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})
</script>
